import React, { useState } from "react";
import type { PartnerAssignment } from "../Lib/partnerApi";
import CourseAttendancePanel from "./CourseAttendancePanel";
import MentorCourseSummary from "./MentorCourseSummary";

export default function CourseCoordinatorWorkspace({ assignments }: { assignments: PartnerAssignment[] }) {
    const courses = assignments.filter((assignment) => assignment.resourceType === "COURSE_RUN" && assignment.assignmentRole === "COORDINATOR");
    const [selected, setSelected] = useState(courses[0]?.resourceId || "");
    if (!courses.length) return null;
    return <section className="rounded-2xl border border-white/10 bg-slate-900 p-5">
        <h2 className="text-lg font-semibold">Coordinator attendance</h2>
        <p className="mt-1 text-sm text-slate-400">Attendance can be corrected after a session ends and remains editable until an admin completes the course.</p>
        <select value={selected} onChange={(event) => setSelected(event.target.value)} className="mt-4 w-full rounded-lg border border-white/10 bg-slate-950 px-3 py-2 text-sm text-white">
            {courses.map((course) => <option key={course.id} value={course.resourceId}>{course.title} · {course.subtitle}</option>)}
        </select>
        {selected && <MentorCourseSummary courseRunId={selected} />}
        {selected && <div className="mt-4"><CourseAttendancePanel courseRunId={selected} /></div>}
    </section>;
}
